/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import LetterNumbersStep from "../LetterNumbersStep.vue";
import LettersFont from "./LettersFont.vue";
import Styles from "./Styles.vue";
import Sizes from "./Sizes.vue";
import Color from "./Color.vue";
import AddLetters from "./AddLetters.vue";
import "./Letters.scss";

export default function Letters(restProps: any) {
  const fontOptions = [
    {
      label: "Promesh",
      value: "promesh"
    },
    {
      label: "Emilio",
      value: "emilio"
    },
    {
      label: "Niconne",
      value: "niconne"
    },
    {
      label: "Squares",
      value: "squares-bold"
    },
    {
      label: "Beantown",
      value: "beantown"
    },
    {
      label: "Octin Sports",
      value: "octin-sports"
    },
    {
      label: "Soccer League",
      value: "soccer-league"
    },
    {
      label: "Rueckwarzsalto",
      value: "rueckwarzsalto"
    },
    {
      label: "Facon",
      value: "facon"
    },
    {
      label: "Varsity Team",
      value: "varsity-team"
    }
  ];

  return (
    <div {...restProps} className={cn("letters", restProps.className)}>
      <LetterNumbersStep
        step={1}
        label="Select Style"
        initiallyOpen={true}
        data-testid="letter-numbers-step"
      >
        <Styles data-testid="styles" />
      </LetterNumbersStep>
      <LetterNumbersStep step={2} label="Select Font" data-testid="letter-numbers-step-1">
        <LettersFont fonts={fontOptions} data-testid="letters-font" />
      </LetterNumbersStep>
      <LetterNumbersStep step={3} label="Select Size" data-testid="letter-numbers-step-2">
        <Sizes data-testid="sizes" />
      </LetterNumbersStep>
      <LetterNumbersStep step={4} label="Select Color" data-testid="letter-numbers-step-3">
        <Color data-testid="color" />
      </LetterNumbersStep>
      <LetterNumbersStep step={5} label="Add Name/Word" data-testid="letter-numbers-step-4">
        <AddLetters data-testid="add-letters" />
      </LetterNumbersStep>
    </div>
  );
}
